<template>
  <div class="progress-wrapper">
    <transition name="fade">
      <router-view class="router-view"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Progress"
    };
  },
  mounted() {
    this.$root.setRootPath("/progress");
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/includes/vars";
@import "~scss/includes/progress";

.progress-wrapper {
  background-color: $deep-purple;
  height: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
